"use strict";

exports.__esModule = true;
exports.Spacer = exports.Row = exports.InputText = exports.Input = exports.FlexRow = exports.ClassifyAddButtonsContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var FlexRow = exports.FlexRow = _styledComponents["default"].div.withConfig({
  displayName: "styles__FlexRow",
  componentId: "sc-lm1sdf-0"
})(["display:flex;flex-direction:row;justify-content:flex-start;align-items:center;flex-wrap:wrap;"]);
var Row = exports.Row = _styledComponents["default"].div.withConfig({
  displayName: "styles__Row",
  componentId: "sc-lm1sdf-1"
})(["display:flex;flex-direction:row;align-items:center;& > *{margin-right:10px;}"]);
var ClassifyAddButtonsContainer = exports.ClassifyAddButtonsContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__ClassifyAddButtonsContainer",
  componentId: "sc-lm1sdf-2"
})(["display:flex;justify-content:end;width:100%;"]);
var Spacer = exports.Spacer = _styledComponents["default"].div.withConfig({
  displayName: "styles__Spacer",
  componentId: "sc-lm1sdf-3"
})(["display:flex;flex-direction:column;flex-basis:10px;"]);
var Input = exports.Input = _styledComponents["default"].div.withConfig({
  displayName: "styles__Input",
  componentId: "sc-lm1sdf-4"
})(["width:130px;"]);
var InputText = exports.InputText = _styledComponents["default"].span.withConfig({
  displayName: "styles__InputText",
  componentId: "sc-lm1sdf-5"
})(["width:125px;"]);